// Global upgrade-prompt event store.
//
// Any code in the app (axios interceptor, button onClick, hook, etc.) can
// imperatively summon the single shared <UpgradePromptModal /> by calling
// `openUpgradeModal({...})`. The modal subscribes via `onChange` and
// renders itself. This avoids prop-drilling a modal trigger through 20
// components.
//
// Payload shape:
//   {
//     feature?: string,    // feature id (e.g. "full_report", "pdf_export")
//     title?: string,      // custom headline override
//     reason?: string,     // 1-sentence "why" copy
//     minTier?: string,    // "investor_lite" | "investor_pro" | "investor_plus"
//     source?: string,     // analytics label — where the prompt came from
//   }

let listener = null;
let pending = null;

export function openUpgradeModal(payload = {}) {
    if (listener) {
        listener(payload);
    } else {
        // Modal hasn't mounted yet — stash the payload and fire when it does.
        pending = payload;
    }
}

// Expose on window for dev/smoke tests so the screenshot tool + manual QA
// can fire the modal without setting up a real paywall scenario. Harmless
// in prod — only useful if you're already in the dev console.
if (typeof window !== "undefined") {
    window.__blOpenUpgradeModal = openUpgradeModal;
}

export function _registerUpgradeModalListener(fn) {
    listener = fn;
    if (pending) {
        const p = pending;
        pending = null;
        fn(p);
    }
    return () => {
        if (listener === fn) listener = null;
    };
}
